<template lang="pug">
div(v-if="showDashBoard")
    Row(style="padding-bottom: 4px;" )
        Col(:lg="24" :md="24" :sm="24")
            Card(:bordered="false" :dis-hover="true" style="border-radius: 5px 5px 0 0;")
                Tabs(v-model="activeTab" @on-click="handleTabChange")
                    TabPane(:label="$t('intelligent.attackPrevious30Seconds')" name="recent_30s") 
                        LineChartWrapper(
                            :chartTitle="$t('intelligent.dualLayerProtectionTitle')"
                            :useBackendDatasetLabel="true"
                            :legendPosition="'top'"
                            :legendAlign="'center'"
                            :withCard="false"
                            :borderWidth="[1.5,2]"
                            :lineTension="[0,0]"
                            :linePointRadius="[4]"
                            :linePointHoverRadius="[8]"
                            :linePointBackgroundColor="['white']"
                            :linePointBorderWidth="[3]"
                            :lineBorderColors="[colorScheme.blue.border,colorScheme.greyBlue.border]"
                            :linePointHoverBorderWidth="[5]"
                            :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)']"
                            :linePointHoverBackgroundColor="['white']"
                            :lineBackgroundGradientStops="[colorScheme.blue.gradientStops]"
                            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                            :sourceData="initData"
                        )
                        p(style="text-align: right;") {{ `${$t("intelligent.ruleId")}: ${ddosAnalyzeId}` }}
                        SingleNumWrapper.singleNumCardMd(
                            :class="'underLineChartWrapper'"
                            :chartTitle="$t('intelligent.affectedRatio')"
                            :numeralFormat="'0.00a'"
                            :numStringSuffix="' %'"
                            :withCard="false"
                            :textInSingleLine="true"
                            maxFontSize="16px"
                            style="text-align: right"
                            :isGetDataFromStore="true"
                            :calculateFormula="affectedRatio"
                        )
                    TabPane(v-if="isWithin3Days" :label="$t('intelligent.attackPlusMinus1Hour')" name="around_1h") 
                        LineChartWrapper(
                            :chartTitle="$t('intelligent.dualLayerProtectionTitlePerMinute')"
                            :useBackendDatasetLabel="true"
                            :legendPosition="'top'"
                            :legendAlign="'center'"
                            :withCard="false"
                            :borderWidth="[2, 2, 2]"
                            :lineTension="[0, 0, 0]"
                            :linePointRadius="[4, 4, 4]"
                            :linePointHoverRadius="[8, 8, 8]"
                            :linePointBackgroundColor="['white', 'white', 'white']"
                            :linePointBorderWidth="[3, 3, 3]"
                            :linePointHoverBorderWidth="[5, 5, 5]"
                            :linePointHoverBorderColor="[colorScheme.red.fill, colorScheme.green.fill, colorScheme.grey.fill]"
                            :linePointHoverBackgroundColor="['white', 'white', 'white']"
                            :lineBorderColors="[colorScheme.red.border, colorScheme.green.border, colorScheme.grey.border]"
                            :lineBackgroundGradientStops="[colorScheme.red.gradientStops, colorScheme.green.gradientStops, colorScheme.grey.gradientStops]"
                            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                            :sourceData="timelineChartData"
                            :yAxisMax="timelineYAxisMax"
                            :xAxisAutoSkip="false"
                            :xAxisMaxTicksLimit="20"
                            :hiddenSeries="['WAF Detection Count']"
                            :verticalLines="getVerticalLineTs()"
                            :verticalLineColors="[colorScheme.purple.border, colorScheme.purple.border]"
                            :verticalLineWidths="[2, 2]"
                            :verticalLineDashes="[[6,6], [6,6]]"
                        )
            Card(:bordered="false" :dis-hover="true" style="border-radius: 0 0 5px 5px;")
                Row(justify="center" style="padding-bottom: 10px;")
                    h4 {{ $t('intelligent.dualLayerProtectionRuleTitle') }}
                Form(:model="wafRuleForm" inline)
                    FormItem(v-for="itemKey in searchKey" :key="itemKey.key" :value="itemKey.key" :label="formLanguage[itemKey.key]" v-if="itemKey.check" style="width: 300px")
                        //- key是date欄位
                        DatePicker(v-if="dateKeys.includes(itemKey.key)" v-model="wafRuleForm[itemKey.key]" type="datetimerange" format="yyyy-MM-dd hh:mm:ss" :placeholder="$t('main.selectTimePlaceholder')" :options="datePickerOptions" :disabled="isFieldDisabled(itemKey.key)")
                        //- key是range欄位
                        div(v-else-if="rangeKeys.includes(itemKey.key)")
                            //- 如果欄位是空的，或是數量少於二，需選擇 '挑選範圍'或'欄位不存在'
                            RadioGroup(:value="((wafRuleForm[itemKey.key] || []).length>=2).toString()" @on-change="changeRadio(itemKey.key, $event)")
                                Radio(label="true" :disabled="isFieldDisabled(itemKey.key)")
                                    span {{ $t(`intelligent.selectOption.range`) }}
                                Radio(label="false" :disabled="isFieldDisabled(itemKey.key)")
                                    span {{ $t(`intelligent.selectOption.NOTEXIST`) }}
                            //- radio選擇'挑選範圍'，需顯示range欄位
                            div(v-if="(wafRuleForm[itemKey.key] || []).length>=2")
                                Row
                                    InputNumber(:min="0" :step="0.1" v-model="wafRuleForm[itemKey.key][0]" :disabled="isFieldDisabled(itemKey.key)")
                                    p(style = "padding-left: 4px; padding-right: 4px;") {{ '~' }}
                                    InputNumber(:min="0" :step="0.1" v-model="wafRuleForm[itemKey.key][1]" :disabled="isFieldDisabled(itemKey.key)")
                        //- default使用下拉多選，並可以自定義選項
                        Select(v-else v-model="wafRuleForm[itemKey.key]" multiple :allow-create="isCanAddCustomOption(itemKey.key)" :filterable="isCanAddCustomOption(itemKey.key)" @on-create="handleCreate(itemKey.key,$event)" :disabled="!isWithin3Days || isFieldDisabled(itemKey.key)")
                            Option(v-for="option in selectOption[itemKey.key]" :key="option.value" :value="option.value") {{option.label}}
                        
                Row(type="flex" justify="end" style="padding-bottom: 10px;")
                    Button(:disabled="!isWithin3Days" style="margin-right: 4px;" type="primary" icon="md-code-working" @click="isShowDrawer = true") {{$t("intelligent.searchRuleBtn")}}
                    Drawer(:title="$t('intelligent.searchRuleBtn')" :closable="false" v-model="isShowDrawer" width="400")
                        div(v-for="itemKey in searchKey")
                            Checkbox(v-model="itemKey.check" :disabled="itemKey.check && searchKey.filter((item)=> item.check).length===1") {{ formLanguage[itemKey.key] }}
                    Button(:disabled="!isWithin3Days || !this.isApplyWaf" style="margin-right: 4px;" type="primary" icon="md-search" @click="searchChartData" :loading="loading") {{$t("intelligent.searchBtn")}}
                    
                    
                    Button(:disabled="!isWithin3Days" type="primary" icon="md-add" :loading="loading" @click="checkStrictHeader") {{ $t("intelligent.createWafRuleBtn") }}
                        Tooltip(placement="top-end" max-width="200")
                            Icon(type="ios-help-circle-outline" style="font-size: 20px; margin-left: 3px;")
                            template(slot="content")
                                p {{ $t("intelligent.createWafRuleTooltip") }}
                        

                
</template>

<script>
import bus from "@/libs/bus.js";
import colorScheme from "@/data/colorScheme";
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";

import {
    getDdosAnalyzeChartData,
    getAvailableQueryKeys,
    getAvailableQueryValues,
    getDdosAbnormalTimeline,
} from "@/api/monitor.js";

import moment from "moment";

export default {
    name: "LineChartDDosAnalyze",
    props: {
        ddosAnalyzeId: { type: String, default: "" },
        selectedAbnormalTime: { type: String, default: "" },
    },
    components: { LineChartWrapper, SingleNumWrapper },
    data() {
        return {
            showDashBoard: false,
            colorScheme: colorScheme,
            initData: {},
            wafRuleForm: {},
            affectedRatio: 0,
            isApplyWaf: false,
            formLanguage: {
                timestamp: this.$t("wafevent.timestamp"),
                bytes_sent: this.$t("wafevent.bytes_sent"),
                request_time: this.$t("wafevent.request_time"),
                upstream_response_time: this.$t("wafevent.upstream_response_time"),
                appProfileName: this.$t("domainsetting.appProfileName"),
                args: this.$t("wafevent.args"),
                country: this.$t("wafevent.country"),
                cus_realy_addr: this.$t("wafevent.cus_realy_addr"),
                hostname: this.$i18n.t("slbsetting.hostname"),
                "user-agent": this.$t("intelligent.form.user-agent"),
                isp: this.$i18n.t("wafrules.wafIsp"),
                originPort: this.$i18n.t("domainsetting.originPort"),
                proxyType: this.$i18n.t("wafrules.wafProxyType"),
                req_id: this.$t("wafevent.req_id"),
                request_method: this.$t("wafevent.request_method"),
                scheme: this.$i18n.t("domainsetting.scheme"),
                server_port: this.$t("wafevent.server_port"),
                servicegroup: this.$t("wafevent.servicegroup"),
                status: this.$t("domainsetting.status"),
                tb_reason: this.$t("wafevent.tb_reason"),
                tb_rule: this.$t("wafevent.tb_rule"),
                tb_type: this.$t("wafevent.tb_type"),
                uri: this.$t("wafevent.uri"),
                server_name: this.$t("wafevent.server_name"),
                group: this.$t("wafevent.group"),
                "accept-encoding": this.$t("intelligent.form.accept-encoding"),
                "accept-language": this.$t("intelligent.form.accept-language"),
                referer: this.$t("intelligent.form.referer"),
                "True-Client-IP": this.$t("intelligent.form.True-Client-IP"),
                "X-Forwarded-For": this.$t("intelligent.form.X-Forwarded-For"),
                tags: this.$t("intelligent.form.tags"),
                "CDN-X-Forwarded-For": this.$t("intelligent.form.CDN-X-Forwarded-For"),
                host: this.$t("intelligent.form.host"),
                originHost: this.$t("intelligent.form.originHost"),
                originHostResolve: this.$t("intelligent.form.originHostResolve"),
                port: this.$t("intelligent.form.port"),
                proxy_host: this.$t("intelligent.form.proxy_host"),
                proxy_protocol_addr: this.$t("intelligent.form.proxy_protocol_addr"),
                realip_remote_addr: this.$t("intelligent.form.realip_remote_addr"),
                remote_addr: this.$t("intelligent.form.remote_addr"),
                remote_user: this.$t("intelligent.form.remote_user"),
                server_protocol: this.$t("intelligent.form.server_protocol"),
                ssl_protocol: this.$t("intelligent.form.ssl_protocol"),
                tb_action: this.$t("intelligent.form.tb_action"),
                tb_isTriggerWafNotBypass: this.$t("intelligent.form.tb_isTriggerWafNotBypass"),
                upstream_addr: this.$t("intelligent.form.upstream_addr"),
                upstream_cache_status: this.$t("intelligent.form.upstream_cache_status"),
                upstream_cache_status_isCached: this.$t("intelligent.form.upstream_cache_status_isCached"),
                upstream_status: this.$t("intelligent.form.upstream_status"),
                raw_uri: this.$t("intelligent.form.raw_uri"),
                raw_args: this.$t("intelligent.form.raw_args"),
                ssl_ja3_hash: this.$t("wafevent.ssl_ja3_hash"),
            },
            isShowDrawer: false,
            searchKey: [],
            nestedReqHeaderKeys: [],
            textKeys: [],
            rangeKeys: [],
            dateKeys: [],
            searchValues: {},
            selectOption: {},
            datePickerOptions: {
                disabledDate: this.isDateDisabled,
            },
            loading: false,
            disabledKeys: [],
            timelineChartData: {
                data: {
                    labels: [],
                    datasets: [],
                },
            },
            searchEnable: false,
            activeTab: "recent_30s",
        };
    },
    methods: {
        handleTabChange(name) {
            this.activeTab = name;
        },
        isCanAddCustomOption(key) {
            return !["request_method", "proxyType"].includes(key);
        },
        // 搜尋報表
        async searchChartData() {
            // 沒有規則ID 不做顯示並查詢
            if (this.ddosAnalyzeId === "") {
                return (this.showDashBoard = false);
            }

            // 驗證timestamp欄位
            if (this.wafRuleForm.timestamp) {
                if (this.wafRuleForm.timestamp.length == 2) {
                    const [start, end] = this.wafRuleForm.timestamp;
                    const startTime = new Date(start).getTime();
                    const endTime = new Date(end).getTime();
                    if (isNaN(startTime) || isNaN(endTime)) {
                        return this.$Message.error(this.$t(`intelligent.timeFormatErrMessage`));
                    }
                    const diffSeconds = (endTime - startTime) / 1000;
                    // bucket 數量有限制 65535 個，在此情境下，每秒做 bucket 最多只能18小時12分16秒
                    if (diffSeconds > 65535) {
                        return this.$Message.error(
                            `${this.$t("intelligent.timeIntervalErrMessage")} 65535 ${this.$t(
                                "intelligent.timeIntervalUnit"
                            )}`
                        );
                    }
                }
            }

            // 建構查詢body
            let queryBody = {};
            this.searchKey
                .filter((itemKey) => itemKey.check)
                .forEach((itemKey) => {
                    const key = itemKey.key;
                    // req_headers的欄位需要額外處理
                    if (this.nestedReqHeaderKeys.includes(key)) {
                        queryBody[`req_headers.${key}`] = this.wafRuleForm[key] || [];
                        return;
                    }
                    // range的欄位沒有異動需要提供default
                    if (this.rangeKeys.includes(key)) {
                        queryBody[key] = this.wafRuleForm[key] || ["NOTEXIST"];
                        return;
                    }
                    queryBody[key] = this.wafRuleForm[key] || [];
                });

            this.loading = true;
            this.initData = await getDdosAnalyzeChartData(
                this.ddosAnalyzeId,
                queryBody,
                this.$store.state.queryGroupName
            );

            if (queryBody && this.searchEnable) this.fetchDdosAbnormalTimeline(queryBody);

            if (Object.keys(this.wafRuleForm).length === 0) {
                this.wafRuleForm = this.initData.data.rule;
            }

            // 攔截比例欄位
            this.affectedRatio = this.initData.data.affected_ratio * 100;
            // 設定interval(sec)
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", {
                key: "dateRangeOptions.index",
                value: "6",
            });

            this.isApplyWaf = this.initData.data.apply_waf;

            bus.$emit("buildChartData", this.initData);

            // 有queryBody才做報表重新渲染
            if (Object.keys(queryBody).length > 0) {
                this.reloadDashBoard();
            }
            this.loading = false;
        },
        async fetchDdosAbnormalTimeline(queryBody) {
            const resolvedRule = Object.keys(this.initData.data.rule).length > 0 ? this.initData.data.rule : queryBody;
            try {
                const res = await getDdosAbnormalTimeline(
                    this.ddosAnalyzeId,
                    {
                        rule: resolvedRule,
                        abnormal_time: this.selectedAbnormalTime,
                    },
                    this.$store.state.queryGroupName
                );

                this.timelineChartData = {
                    data: res.data.chart,
                };

                this.searchEnable = true;
            } catch (err) {
                console.log(err);
            }
        },
        getVerticalLineTs() {
            const startTs = new Date(this.selectedAbnormalTime).getTime();
            const endTs = startTs + 30 * 1000; // 30 秒
            return [startTs, endTs];
        },
        // 取得可以做query的欄位
        async getKeys() {
            const result = await getAvailableQueryKeys();
            const { success, textKeys, rangeKeys, dateKeys, nestedReqHeaderKeys, disabledKeys } = result.data;
            if (success) {
                this.disabledKeys = disabledKeys;
                this.nestedReqHeaderKeys = nestedReqHeaderKeys;
                this.textKeys = textKeys;
                this.rangeKeys = rangeKeys;
                this.dateKeys = dateKeys;
                this.searchKey = nestedReqHeaderKeys
                    .concat(textKeys)
                    .concat(rangeKeys)
                    .concat(dateKeys)
                    .map((itemKey) => {
                        return {
                            check: this.wafRuleForm[itemKey] !== undefined,
                            key: itemKey,
                        };
                    });
            }
        },
        // 取得各欄位的下拉選項
        async getOptions() {
            const result = await getAvailableQueryValues();
            const { success, values } = result.data;
            if (success) {
                this.searchValues = values;
            }
        },
        // 重新渲染報表
        reloadDashBoard() {
            this.showDashBoard = false;
            this.$nextTick(() => {
                this.showDashBoard = true;
            });
        },
        // 規則欄位新增value
        handleCreate(key, val) {
            if (!this.wafRuleForm[key]) {
                this.$set(this.wafRuleForm, key, []);
            }
            this.wafRuleForm[key].push(val);
            this.setOptions(); // 更新下拉
        },
        // 設定個欄位的下拉選項
        setOptions() {
            let selectOption = {};
            this.searchKey
                .filter((itemKey) => itemKey.key !== "timestamp")
                .forEach((itemKey) => {
                    const option = (this.wafRuleForm[itemKey.key] || [])
                        .filter((item) => item !== "NOTEXIST" && item !== "EMPTY")
                        .map((item) => {
                            return {
                                value: item,
                                label: item,
                            };
                        });
                    const fieldValues = this.searchValues[itemKey.key].map((item) => {
                        return {
                            value: item,
                            label: this.$te(`intelligent.form.${item}`)
                                ? this.$t(`intelligent.selectOption.${item}`)
                                : item,
                        };
                    });
                    selectOption[itemKey.key] = [...new Set(option.concat(fieldValues))];
                });
            this.selectOption = selectOption;
        },
        // radio異動的動作
        changeRadio(key, value) {
            this.$set(this.wafRuleForm, key, []);
            let newValue = [0, 10];
            if (value === "false") {
                newValue = ["NOTEXIST"];
            }
            newValue.forEach((val) => {
                this.handleCreate(key, val);
            });
        },
        // DatePicker可挑選的日期
        isDateDisabled(date) {
            const endOfDayMillionSeconds = moment().endOf("day").valueOf();
            const dayInMillionSeconds = 24 * 60 * 60 * 1000;
            return (
                (date && date.valueOf() < endOfDayMillionSeconds - dayInMillionSeconds * 2) ||
                (date && date.valueOf() > endOfDayMillionSeconds)
            );
        },
        // 控制欄位是否可以使用
        isFieldDisabled(key) {
            return this.disabledKeys.includes(key);
        },
        filterRuleByVisibleFields() {
            return this.searchKey
                .filter((item) => item.check) // 只保留有勾選 check: true 的欄位
                .map((item) => item.key) // 抽出欄位 key 清單
                .reduce((result, key) => {
                    // 從 wafRuleForm 中挑出符合欄位，組成新的 filteredWafRulesData 物件
                    if (key in this.wafRuleForm) {
                        result[key] = this.wafRuleForm[key];
                    }
                    return result;
                }, {});
        },
        // 導航至 waf 規則頁面
        goToWafRules() {
            // 取得有勾選欄位的 wafRule 資料
            const filteredWafRulesData = this.filterRuleByVisibleFields();
            sessionStorage.setItem("wafRulesData", JSON.stringify(filteredWafRulesData));
            this.$router.push({ name: "WafRules" });
        },
        checkStrictHeader() {
            const filtered = this.filterRuleByVisibleFields();
            const conflictingHeaderKeys = this.getConflictingHeaderKeys(filtered);

            if (conflictingHeaderKeys.length === 0) {
                this.goToWafRules();
                return;
            }

            const formattedList = conflictingHeaderKeys.map((key) => `<li>${key}</li>`).join("");

            this.$Modal.confirm({
                title: this.$t("intelligent.strictHeaderTitle"),
                content: `
                    <div style="margin-bottom: 8px;">
                        ${this.$t("intelligent.strictHeaderConflictTip1")}
                    </div>
                    <ul style="padding-left: 20px;">${formattedList}</ul>
                    <div style="margin-top: 8px;">
                        ${this.$t("intelligent.strictHeaderConflictTip2")}
                    </div>
                `,
                okText: this.$t("intelligent.strictHeaderOk"),
                cancelText: this.$t("intelligent.strictHeaderCancel"),
                closable: true,
                onOk: () => {
                    this.goToWafRules();
                },
            });
        },
        getConflictingHeaderKeys(data) {
            const headerKeys = [
                "accept-encoding",
                "accept-language",
                "CDN-X-Forwarded-For",
                "server_name",
                "referer",
                "user-agent",
                "X-Forwarded-For",
            ];

            return headerKeys.filter((key) => {
                const values = data[key] || [];
                return values.includes("NOTEXIST") && values.length > 1;
            });
        },
    },
    mounted() {},
    async created() {
        await this.searchChartData();
        await this.getKeys();
        await this.getOptions();
        await this.fetchDdosAbnormalTimeline();
        this.setOptions();
        this.reloadDashBoard();
    },
    computed: {
        // 動態判斷是否在 3 天內
        isWithin3Days() {
            if (!this.selectedAbnormalTime) return false;
            const diffDays = moment().diff(moment(this.selectedAbnormalTime), "days");
            return diffDays < 3;
        },
        timelineYAxisMax() {
            const allValues = this.timelineChartData.data.datasets.reduce(
                (acc, ds) => (Array.isArray(ds.data) ? acc.concat(ds.data) : acc),
                []
            );
            return Math.max(...allValues);
        },
    },
    watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/LineChartDDosAnalyze.vue